/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

import React from 'react';

export function Ellipse() {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle id="Ellipse 465" cx="4" cy="4" r="3" fill="white" stroke="#3370FF" strokeWidth="2" />
    </svg>
  );
}
